import api from '../httpClient';
import apiRoutes from '../apiRoutes';

const unwrapList = (data) => Array.isArray(data) ? data : (data?.results || []);

export const fetchTransactions = async () => {
  const response = await api.get(apiRoutes.dealbridge.transactions);
  return unwrapList(response.data);
};

export const fetchTransaction = async (transactionId) => {
  const response = await api.get(apiRoutes.dealbridge.transaction(transactionId));
  return response.data;
};

export const performTaskAction = async (taskId, action, payload = {}) => {
  const response = await api.post(
    apiRoutes.dealbridge.transactionTaskAction(taskId, action),
    payload,
  );
  return response.data;
};
